import BaseApi from "./BaseApi";

export default class ComprovanteService {

    static get(cdEventoCadastro, nrOpcao) {
        return BaseApi.get(`comprovante/v1/getComprovante/${cdEventoCadastro}/${nrOpcao}`);
    }

    static gerarBoleto(command) {
        return BaseApi.post(`comprovante/v1/gerarBoleto`, command);
    }
}